// Raporlar (C58–C68): yönlendirmeler (izin + bayrak korumalı, tembel yüklenir).
import { Route } from 'react-router';
import { guard, load } from '../route-utils';

const ReportsHome = load(() => import('./ReportsHome'), 'ReportsHome');
const ReportPage = load(() => import('./ReportPage'), 'ReportPage');
const Co2Report = load(() => import('./Co2Report'), 'Co2Report');
const CostReport = load(() => import('./ReportPage'), 'CostReport');

export const reportsRoutes = (
  <>
    <Route path="raporlar" element={guard(ReportsHome, 'reports')} />
    <Route path="raporlar/co2" element={guard(Co2Report, 'reports')} />
    <Route path="raporlar/yolcu-basi-maliyet" element={guard(CostReport, 'reports', { flag: 'FINANCE' })} />
    <Route path="raporlar/:slug" element={guard(ReportPage, 'reports')} />
  </>
);
